import { origin_point_engine_api } from '@/lib/axios-client'

/** 审核操作（通过/拒绝） */
export async function postReviewEngine(input: {
  engineId: string
  action: 'approve' | 'reject'
  note: string
}) {
  return origin_point_engine_api({
    url: `/admin/engines/${input.engineId}/review`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: {
      action: input.action,
      note: input.note,
    },
  })
}
